import {CurrentTimeStore} from 'stores/current_time_store';

export const currentTimeStore = new CurrentTimeStore();
